export function isValidMongolianPhone(phone: string) {
  const digits = phone.replace(/\D/g, "");
  if (digits.length === 8) return /^[689]\d{7}$/.test(digits);
  if (digits.length === 11 && digits.startsWith("976")) return /^[689]\d{7}$/.test(digits.slice(3));
  return false;
}
